import { FeatureEnum } from '../enums/feature.enum';
import { IFeatureList } from '../interfaces/feature-permissions.interface';

export const featuresWithPermissions: IFeatureList = {
    my_account: {
        feature: FeatureEnum.MY_ACCOUNT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8, 9],
        byPassImpersonation: false,
    },
    header_can_impersonate: {
        feature: FeatureEnum.HEADER_CAN_IMPERSONATE,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8, 9],
        byPassImpersonation: true,
    },
    header_cannot_impersonate: {
        feature: FeatureEnum.HEADER_CANNOT_IMPERSONATE,
        accessLevelRequired: [1],
        byPassImpersonation: false,
    },
    messaging: {
        feature: FeatureEnum.MESSAGING,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },

    // REPERTOIRE

    // admin
    repertoire_edit_administrator: {
        feature: FeatureEnum.EDIT_ADMIN,
        accessLevelRequired: [1],
        byPassImpersonation: false,
    },
    repertoire_view_administrator: {
        feature: FeatureEnum.VIEW_ADMIN,
        accessLevelRequired: [1],
        byPassImpersonation: false,
    },
    //school
    repertoire_edit_school: {
        feature: FeatureEnum.EDIT_SCHOOL,
        accessLevelRequired: [1],
        byPassImpersonation: false,
    },
    repertoire_view_school: {
        // !! attention, view que dans la popup header !!
        feature: FeatureEnum.VIEW_SCHOOL,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //echevin
    repertoire_edit_alderman: {
        feature: FeatureEnum.EDIT_ECHEVIN,
        accessLevelRequired: [1, 2],
        byPassImpersonation: false,
    },
    repertoire_read_alderman: {
        feature: FeatureEnum.READ_ECHEVIN,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_view_alderman: {
        feature: FeatureEnum.VIEW_ECHEVIN,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: false,
    },
    //directeur
    repertoire_edit_director: {
        feature: FeatureEnum.EDIT_DIRECTOR,
        accessLevelRequired: [1, 2, 3],
        byPassImpersonation: false,
    },
    repertoire_read_director: {
        feature: FeatureEnum.READ_DIRECTOR,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_view_director: {
        feature: FeatureEnum.VIEW_DIRECTOR,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: false,
    },
    //sous-directeur
    repertoire_edit_assistant: {
        feature: FeatureEnum.EDIT_ASSISTANT,
        accessLevelRequired: [1, 2, 3, 4],
        byPassImpersonation: false,
    },
    repertoire_read_assistant: {
        feature: FeatureEnum.READ_ASSISTANT,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_view_assistant: {
        feature: FeatureEnum.VIEW_ASSISTANT,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: false,
    },
    //secretaire
    repertoire_edit_secretary: {
        feature: FeatureEnum.EDIT_SECRETARY,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_secretary: {
        feature: FeatureEnum.EDIT_SECRETARY,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: true,
    },
    repertoire_view_secretary: {
        feature: FeatureEnum.VIEW_SECRETARY,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //professeur
    repertoire_edit_teacher: {
        feature: FeatureEnum.EDIT_TEACHER,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_teacher: {
        feature: FeatureEnum.EDIT_TEACHER,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: true,
    },
    repertoire_view_teacher: {
        feature: FeatureEnum.VIEW_TEACHER,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //supervisor
    repertoire_edit_supervisor: {
        feature: FeatureEnum.EDIT_SUPERVISOR,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_supervisor: {
        feature: FeatureEnum.EDIT_SUPERVISOR,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: true,
    },
    repertoire_view_supervisor: {
        feature: FeatureEnum.VIEW_SUPERVISOR,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //parent
    repertoire_edit_parent: {
        feature: FeatureEnum.EDIT_PARENT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_parent: {
        feature: FeatureEnum.READ_PARENT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    repertoire_view_parent: {
        feature: FeatureEnum.VIEW_PARENT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //eleve
    repertoire_edit_student: {
        feature: FeatureEnum.EDIT_STUDENT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_edit_student_calendar: {
        feature: FeatureEnum.EDIT_STUDENT_CALENDAR,
        accessLevelRequired: [2, 3, 4, 5, 8],
        byPassImpersonation: true,
    },
    repertoire_read_student: {
        feature: FeatureEnum.READ_STUDENT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    repertoire_view_student: {
        feature: FeatureEnum.VIEW_STUDENT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    repertoire_delete_student: {
        feature: FeatureEnum.DELETE_STUDENT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    //classe
    repertoire_edit_class: {
        feature: FeatureEnum.EDIT_CLASS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_class: {
        feature: FeatureEnum.READ_CLASS,
        accessLevelRequired: [2, 3, 4, 5, 6, 7],
        byPassImpersonation: true,
    },
    repertoire_view_class: {
        feature: FeatureEnum.VIEW_CLASS,
        accessLevelRequired: [2, 3, 4, 5, 6, 7],
        byPassImpersonation: true,
    },
    repertoire_view_class_as_parent: {
        feature: FeatureEnum.VIEW_CLASS_AS_PARENT,
        accessLevelRequired: [8],
        byPassImpersonation: false,
    },
    //groupe perso
    repertoire_edit_group_perso: {
        feature: FeatureEnum.EDIT_GROUP_PERSO,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_group_perso: {
        feature: FeatureEnum.READ_GROUP_PERSO,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    repertoire_view_group_perso: {
        feature: FeatureEnum.VIEW_GROUP_PERSO,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //groupe predefined
    repertoire_edit_group_predefined: {
        feature: FeatureEnum.READ_GROUP_PREDEFINED,
        accessLevelRequired: [],
        byPassImpersonation: false,
    },
    repertoire_read_group_predefined: {
        feature: FeatureEnum.READ_GROUP_PREDEFINED,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    repertoire_view_group_predefined: {
        feature: FeatureEnum.VIEW_GROUP_PREDEFINED,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    //contacts
    repertoire_edit_contact: {
        feature: FeatureEnum.EDIT_CONTACT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_read_contact: {
        feature: FeatureEnum.EDIT_CONTACT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    repertoire_view_contact: {
        feature: FeatureEnum.VIEW_CONTACT,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    //proches
    repertoire_edit_relative: {
        feature: FeatureEnum.EDIT_RELATIVE,
        accessLevelRequired: [8],
        byPassImpersonation: true,
    },
    repertoire_view_relative: {
        feature: FeatureEnum.VIEW_RELATIVE,
        accessLevelRequired: [8],
        byPassImpersonation: false,
    },
    repertoire_edit_relative_as_employee: {
        feature: FeatureEnum.EDIT_RELATIVE_AS_EMPLOYEE,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
        mustBeImpersonated: true,
    },
    repertoire_view_relative_as_employee: {
        feature: FeatureEnum.VIEW_RELATIVE_AS_EMPLOYEE,
        accessLevelRequired: [6, 7],
        byPassImpersonation: true,
        mustBeImpersonated: true,
    },
    //repertoire autres
    repertoire_create_entity: {
        feature: FeatureEnum.CREATE_ENTITY,
        accessLevelRequired: [1, 2, 3, 4, 5, 8, 9],
        byPassImpersonation: true,
    },
    repertoire_create_emloyee: {
        feature: FeatureEnum.CREATE_EMPLOYEE,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    repertoire_view_adress_or_phone: {
        feature: FeatureEnum.VIEW_ADRESS_PHONE,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7],
        byPassImpersonation: false,
    },
    repertoire_view_relative_adress_or_phone: {
        feature: FeatureEnum.VIEW_RELATIVE_ADRESS_OR_PHONE,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    repertoire_is_active_switch_change: {
        feature: FeatureEnum.IS_ACTIVE_SWITCH_CHANGE,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },

    // SHOP
    shopping_nav: {
        feature: FeatureEnum.SHOPPING_NAV,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },
    shopping_export: {
        feature: FeatureEnum.SHOPPING_EXPORT,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    charge_decharge: {
        feature: FeatureEnum.SHOPPING_CHARGE_DECHARGE,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    shopping_history_search: {
        feature: FeatureEnum.SHOPPING_HISTORY_SEARCH,
        accessLevelRequired: [2, 3, 4, 5, 6, 7],
        byPassImpersonation: false,
    },
    delete_order: {
        feature: FeatureEnum.DELETE_ORDER,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },

    // SHOP - WALLET (DASHBOARD)
    wallet_dashboard: {
        feature: FeatureEnum.WALLET_DASHBOARD,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: true,
    },
    wallet_admin: {
        feature: FeatureEnum.WALLET_ADMIN,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: false,
    },
    wallet_action: {
        feature: FeatureEnum.WALLET_ACTION,
        accessLevelRequired: [1, 2, 3, 4, 5, 8],
        byPassImpersonation: true,
    },
    wallet_action_employee: {
        feature: FeatureEnum.WALLET_ACTION_EMPLOYEE,
        accessLevelRequired: [1, 2, 3, 4, 5],
        byPassImpersonation: true,
    },
    wallet_student: {
        feature: FeatureEnum.WALLET_STUDENT,
        accessLevelRequired: [8, 9],
        byPassImpersonation: false,
    },
    wallet_delete_transaction: {
        feature: FeatureEnum.WALLET_DELETE_TRANSACTION,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    wallet_history_filter: {
        feature: FeatureEnum.WALLET_HISTORY_FILTER,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    wallet_view_price: {
        feature: FeatureEnum.WALLET_VIEW_PRICE,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },
    wallet_view_status: {
        feature: FeatureEnum.WALLET_VIEW_STATUS,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },

    // SHOP - MEALS
    meals_nav: {
        feature: FeatureEnum.MEALS_NAV,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },

    meals_parent_disclaimer: {
        feature: FeatureEnum.MEALS_PARENT_DISCLAIMER,
        accessLevelRequired: [8],
        byPassImpersonation: false,
    },

    meals_access: {
        feature: FeatureEnum.MEALS_ACCESS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },

    meals_calendar_as_parent: {
        feature: FeatureEnum.MEALS_ACCESS_AS_PARENT,
        accessLevelRequired: [8],
        byPassImpersonation: true,
        mustBeImpersonated: true,
    },

    meals_access_as_student: {
        feature: FeatureEnum.MEALS_ACCESS_AS_STUDENT,
        accessLevelRequired: [9],
        byPassImpersonation: false,
    },

    meals_booking_employees: {
        feature: FeatureEnum.MEALS_BOOKING_EMPLOYEES,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },

    meals_booking_students: {
        feature: FeatureEnum.MEALS_BOOKING_STUDENTS,
        accessLevelRequired: [9],
        byPassImpersonation: false,
    },

    meals_tabs: {
        feature: FeatureEnum.MEALS_TABS,
        accessLevelRequired: [2, 3, 4, 5, 9],
        byPassImpersonation: true,
    },

    meals_tabs_as_student: {
        feature: FeatureEnum.MEALS_TABS_AS_STUDENT,
        accessLevelRequired: [9],
        byPassImpersonation: false,
    },

    meals_settings: {
        feature: FeatureEnum.MEALS_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    meals_history: {
        feature: FeatureEnum.MEALS_HISTORY,
        accessLevelRequired: [2, 3, 4, 5, 8],
        byPassImpersonation: true,
    },
    meals_booking_history: {
        feature: FeatureEnum.MEALS_HISTORY,
        accessLevelRequired: [2, 3, 4, 5, 9],
        byPassImpersonation: false,
    },
    meals_view_settings: {
        feature: FeatureEnum.MEALS_VIEW_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },

    // SHOP - NURSERY
    nursery_nav: {
        feature: FeatureEnum.NURSERY_NAV,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },

    nursery_settings: {
        feature: FeatureEnum.NURSERY_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    nursery_encode: {
        feature: FeatureEnum.NURSERY_ENCODE,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    nursery_view_settings: {
        feature: FeatureEnum.NURSERY_VIEW_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },
    nusery_tabs: {
        feature: FeatureEnum.NURSERY_TABS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },

    nursery_qr_show: {
        feature: FeatureEnum.NURSERY_QR,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: true,
    },

    nursery_delete: {
        feature: FeatureEnum.NURSERY_DELETE,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },

    // SHOP - ACTIVITIES
    activities_nav: {
        feature: FeatureEnum.ACTIVITIES_NAV,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },

    // SHOP - HOMEWORK SCHOOL
    homework_school_nav: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_NAV,
        accessLevelRequired: [2, 3, 4, 5, 8, 9],
        byPassImpersonation: false,
    },

    homework_school_parent_disclaimer: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_PARENT_DISCLAIMER,
        accessLevelRequired: [8],
        byPassImpersonation: false,
    },

    homework_school_access: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_ACCESS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: true,
    },

    homework_calendar_as_parent: {
        feature: FeatureEnum.HOMEWORK_CALENDAR_AS_PARENT,
        accessLevelRequired: [8],
        byPassImpersonation: true,
        mustBeImpersonated: true,
    },

    homework_school_booking_employees: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_BOOKING_EMPLOYEES,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },

    homework_school_booking_students: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_BOOKING_STUDENTS,
        accessLevelRequired: [9],
        byPassImpersonation: false,
    },

    homework_school_tabs: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_TABS,
        accessLevelRequired: [2, 3, 4, 5, 9],
        byPassImpersonation: false,
    },
    homework_school_settings: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    homework_school_history: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_HISTORY,
        accessLevelRequired: [2, 3, 4, 5, 8],
        byPassImpersonation: true,
    },
    homework_school_booking_history: {
        feature: FeatureEnum.HOMEWORK_SCHOOL_HISTORY,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8],
        byPassImpersonation: true,
    },
    homework_view_settings: {
        feature: FeatureEnum.HOMEWORK_VIEW_SETTINGS,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },

    // EVENTS
    events_booking_employees: {
        feature: FeatureEnum.EVENTS_BOOKING_EMPLOYEES,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },
    events_filters_education_level: {
        feature: FeatureEnum.EVENTS_FILTERS_EDUCATION_LEVEL,
        accessLevelRequired: [2, 3, 4, 5, 6, 7],
        byPassImpersonation: true,
    },

    // CLOUD
    cloud_nav: {
        feature: FeatureEnum.CLOUD_NAV,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8, 9],
        byPassImpersonation: false,
    },

    cloud_actions: {
        feature: FeatureEnum.CLOUD_ACTIONS,
        accessLevelRequired: [2, 3, 4, 5, 6, 7],
        byPassImpersonation: false,
    },

    cloud_create_folder: {
        feature: FeatureEnum.CLOUD_CREATE_FOLDER,
        accessLevelRequired: [2, 3, 4, 5],
        byPassImpersonation: false,
    },

    // CALENDAR
    calendar_nav: {
        feature: FeatureEnum.CALENDAR_NAV,
        accessLevelRequired: [2, 3, 4, 5, 6, 7, 8, 9],
        byPassImpersonation: false,
    },

    admin_settings_nav: {
        feature: FeatureEnum.ADMIN_SETTINGS,
        accessLevelRequired: [1],
        byPassImpersonation: false,
    },

    // DEFAULT
    open_access: {
        feature: FeatureEnum.OPEN_ACCESS,
        accessLevelRequired: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        byPassImpersonation: true,
    },
};
